import { motion } from "framer-motion";

const VIEWPORT = { once: true, margin: "-60px" };
const WHILE_IN_VIEW = { opacity: 1, y: 0 };
const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={WHILE_IN_VIEW}
      viewport={VIEWPORT}
      transition={{ duration: 0.55, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export default Reveal;
